import { Flex, OptionTypeBase, Box, Checkbox, Text } from '@cad-arc';
import { UnitFiltersForm } from '@mark43/cad-api';
import { useMemo } from 'react';
import { Control, Controller, useFormContext } from 'react-hook-form';
import { BaseSelect } from '../../../forms/inputs/base-select';

export function FilterSelect(props: {
    label: string;
    filterName: keyof UnitFiltersForm;
    options: OptionTypeBase[];
    control: Control<UnitFiltersForm>;
    isLoading?: boolean;
}): React.ReactElement {
    const form = useFormContext();
    const selectedOptionValues = form.watch(props.filterName);
    const allOptionValues = useMemo(() => props.options.map((option) => option.value), [
        props.options,
    ]);
    const isSelectingAll = useMemo(
        () => allOptionValues.length > 0 && selectedOptionValues.length === allOptionValues.length,
        [selectedOptionValues, allOptionValues]
    );
    return (
        <Box mt="4">
            <Flex>
                <Text variant="bodyMd">{props.label}</Text>
                <Box ml="auto" alignSelf="flex-end">
                    <Checkbox
                        isChecked={isSelectingAll}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            if (e.target.checked) {
                                form.setValue(props.filterName, allOptionValues);
                            } else {
                                form.setValue(props.filterName, []);
                            }
                        }}
                    >
                        Select All
                    </Checkbox>
                </Box>
            </Flex>
            <Flex mt="2">
                <Controller
                    name={props.filterName}
                    render={({ field }) => (
                        <BaseSelect
                            {...field}
                            isMultiple
                            options={props.options}
                            truncateSelectedCount={2}
                            isLoading={props.isLoading}
                        />
                    )}
                ></Controller>
            </Flex>
        </Box>
    );
}
